import { isEmpty, isUndefined } from "lodash";
import { paramsChecking } from "utils/helpersInTs/helpersInTs";
import { DataFormat } from "./DataFormat";

export class StringFormat {
  static parseNoteString = (
    note: string,
  ): Record<string, string | string[]> => {
    if (!note) return;
    const parts = note.split("|");
    const result: Record<string, string | string[]> = {};
    const products: string[] = [];

    for (const part of parts) {
      if (part.includes("=")) {
        const [key, value] = part.split("=");
        result[key] = value;
      } else if (part.trim() !== "") {
        products.push(part);
      }
    }

    if (products.length > 0) {
      result["product"] = products.length === 1 ? products[0] : products;
    }

    return result;
  };

  static dataFormater = (number: number) => {
    if (number >= 1000000000) {
      return (number / 1000000000).toString() + "B";
    } else if (number >= 1000000) {
      return (number / 1000000).toString() + "M";
    } else if (number >= 1000) {
      return (number / 1000).toString() + "K";
    } else {
      return number.toString();
    }
  };

  static checkLowerCase = (val: string) => {
    if (!isEmpty(val) && val === val?.toLowerCase()) {
      return val.charAt(0).toUpperCase() + val.slice(1);
    } else {
      return val;
    }
  };

  static isHTML(str: string): boolean {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
  }

  static isFloatInString = (value: string) => {
    const num = parseFloat(value);
    if (!isNaN(num) && !Number.isInteger(num)) {
      return num;
    } else {
      return parseInt(value) || 0;
    }
  };

  static getQueryString = (value: Array<string>, key: string) => {
    if (isEmpty(value) || isUndefined(value) || value?.includes("")) {
      return undefined;
    } else {
      value?.forEach((element) => paramsChecking(element, "select"));
      return value
        ?.filter((item) => item !== undefined)
        ?.map((child, index) => `${key}[${index}]=${child}`)
        ?.join("&");
    }
  };

  static buildQueryString<T extends Object>(params: T): string {
    const entries = Object.entries(params).filter(
      ([_, vals]) =>
        Array.isArray(vals) && !isEmpty(vals) && !vals?.includes(""),
    );
    return entries
      .map(([keys, vals]) =>
        this.getQueryString(vals as unknown as Array<string>, keys),
      )
      .filter(Boolean)
      .join("&");
  }

  static buildListUrl<T extends Object>(basePath: string, params: T): string {
    const queryString = this.buildQueryString(params || {});
    return `${basePath}${!isEmpty(queryString) ? `?${queryString}` : ""}`;
  }

  static buildExportUrl<T extends Object>(basePath: string, params: T): string {
    const queryString = this.buildQueryString(params);
    const prepared = DataFormat.prepareParamsForApi(params);
    const queryParams = new URLSearchParams(
      prepared as unknown as Record<string, string>,
    ).toString();
    return `${basePath}${!isEmpty(queryString) ? `?${queryString}` : ""}${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`
      }`;
  }

  static capitalizeFirstLetter(value: string) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}

export const { parseNoteString, dataFormater, checkLowerCase } = StringFormat;
